import { makeMentionsSelector } from "../../redux/selectors/mentions";
import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { recallNumber } from "../../utils/Number";
import { isNullOrNaN, isValueInChoiceList } from "../../utils";

const maxValueKey = "MaxValue";
const minValueKey = "MinValue";
const errorKey = "OutOfBounds";

export function bounds(question, variable) {
    const { name: variableName } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const { settings } = question;
        const { interview } = getState();
        const max = recallNumber(settings[maxValueKey], interview);
        const min = recallNumber(settings[minValueKey], interview);

        if (!isNullOrNaN(max) && !isNullOrNaN(min)) {
            const mentions = mentionsSelector(getState());
            if (mentions.length) {
                const mentionValue = mentions[0].value;
                const num = recallNumber(mentionValue, interview);
                const isValid =
                    isValueInChoiceList(mentionValue, variable) || (num <= max && num >= min);
                if (!isValid) {
                    return {
                        variableName,
                        error: { key: errorKey, args: { max: String(max), min: String(min) } },
                    };
                }
            }
        }
        return null;
    };
}
